import {Component, Input, Output, EventEmitter, ViewEncapsulation} from '@angular/core';
import {CmlSourceSectionComponent} from '../cml-source-section/cml-source-section.component';
import {HighlightPipe} from '../highlight.pipe';
import {EventWithSources, TplSource, TplConfig, SourceType, allSelected, someSelected} from '../cml-types';

@Component({
  selector: 'cml-event-accordion',
  standalone: true,
  imports: [CmlSourceSectionComponent, HighlightPipe],
  encapsulation: ViewEncapsulation.None,
  template: `
    <div class="liEv" [class.liEvon]="expanded">
      <div class="hliEv" (click)="toggleExpand.emit(event._id)">
        <div class="contcheckEv">
          <input type="checkbox" class="inCheckEv" [id]="'ev' + event._id"
                 [checked]="isAllChecked()"
                 [indeterminate]="isIndeterminate()"
                 (click)="$event.stopPropagation()"
                 (change)="toggleAll.emit()">
          <label class="labCheckEv" [for]="'ev' + event._id" (click)="$event.stopPropagation()">
            <i class="fas fa-check icCheckEv"></i>
          </label>
        </div>
        <div class="nameEv" [innerHTML]="event.name | highlight:searchTerm"></div>
        <div class="checkTplEv">
          <div class="bulcheckTplEv" [class.bulce2]="checkedCount() > 0">
            <span class="qtcheckev">{{ checkedCount() }}</span>
            <span> / {{ totalCount() }}</span>
          </div>
          <div class="txtcheckTplEv">
            {{ checkedCount() <= 1 ? 'billet sélectionné' : 'billets sélectionnés' }}
          </div>
        </div>
        <div class="contextandEv"><i class="far fa-chevron-down icextandEv"></i></div>
      </div>
      <div class="contblocSource">
        @for (source of event.sources; track source.type) {
          <cml-source-section
            [source]="source"
            [eventId]="event._id"
            [expanded]="expandedSourceType === source.type && expanded"
            [configs]="configs"
            [searchTerm]="searchTerm"
            [tplGroups]="event.tplGroups || []"
            (toggleExpand)="toggleSource.emit({eventId: event._id, sourceType: source.type})"
            (toggleAll)="sourceToggleAll.emit($event)"
            (tplToggle)="tplToggle.emit($event)"
            (tplNfcChange)="tplNfcChange.emit($event)"
            (tplScanChange)="tplScanChange.emit($event)"
            (tplColorChange)="tplColorChange.emit($event)"
          />
        }
      </div>
    </div>
  `
})
export class CmlEventAccordionComponent {
  @Input() event!: EventWithSources;
  @Input() expanded = false;
  @Input() expandedSourceType: SourceType | null = null;
  @Input() configs: Record<string, TplConfig> = {};
  @Input() searchTerm = '';
  @Output() toggleExpand = new EventEmitter<string>();
  @Output() toggleAll = new EventEmitter<void>();
  @Output() toggleSource = new EventEmitter<{eventId: string; sourceType: SourceType}>();
  @Output() sourceToggleAll = new EventEmitter<TplSource[]>();
  @Output() tplToggle = new EventEmitter<string>();
  @Output() tplNfcChange = new EventEmitter<{id: string; value: string}>();
  @Output() tplScanChange = new EventEmitter<{id: string; value: number}>();
  @Output() tplColorChange = new EventEmitter<{id: string; value: string}>();

  checkedCount(): number {
    return this.event.sources.reduce((sum, s) =>
      sum + s.templates.filter(t => this.configs[t._id]?.checked).length, 0);
  }

  totalCount(): number {
    return this.event.sources.reduce((sum, s) => sum + s.templates.length, 0);
  }

  isAllChecked(): boolean {
    return allSelected(this.checkedCount(), this.totalCount());
  }

  isIndeterminate(): boolean {
    return someSelected(this.checkedCount(), this.totalCount());
  }
}
